import { useState, useEffect, useContext, useRef } from "react";

import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";

import { RiGroupLine, RiUserLine } from "react-icons/ri";
import { Loading, useRedirect } from "react-admin";
import { BiChevronDown, BiSearch } from "react-icons/bi";
import {
  AttendeeFilters,
  // BadgePreview,
  GenericList,
  filterOptions,
  DropdownButton,
  SimpleActionDialog,
  // CSVUploader,
} from "../../components";
import IAttendee, {
  registrationStatus,
} from "../../dataProvider/interfaces/IAttendee";
import { StoreContext } from "../../store/Store";
import { routePaths } from "../../baseLayout/SidebarMenu";
// import Chip from "@mui/material/Chip";
import { theme } from "../../theme";
// import ImportedDataList from "../CreateEventFlow/ImportedDataList/ImportedDataList";
import { jobStatus } from "../../dataProvider/interfaces/IEvent";
import NotificationMessage, {
  notificationType,
} from "../../components/NotificationMessage/NotificationMessage";
import { useParams } from "react-router";
import { dataType } from "../../components/GenericList/GenericList";
import { FiLogOut } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import { BiX, BiTrash } from "react-icons/bi";
import { APIContext } from "../../store/APIStore";
import { useHasPermissions, useHasRole } from "../../hooks/useHasPermissions";
import { PERMISSIONS, ROLES } from "../../roles";
import CSVUploadFlow from "../EventSessions/CSVUploadFlow/CSVUploadFlow";
import FdButton from "../../components/UIComponents/Button/FdButton";
import FdTextField from "../../components/UIComponents/TextField/FdTextfield";
import FdTypography from "../../components/UIComponents/Typography/FdTypography";
import React from "react";
import FdChip from "../../components/UIComponents/Chip/FdChip";
import { attendeesOverview as classes } from "./styles";
import { SingleTextField } from "../../components/SingleTextField/singleTextField";
import { Props as dialogType } from "./../../components/SimpleActionDialog/SimpleActionDialog";
import CategoryOverview from "../AttendeeEdit/AttendeeCategory/CategoryOverview";
import { BiGridAlt } from "react-icons/bi";

const AttendeesOverview = () => {
  const [attendees, setAttendees] = useState<IAttendee[]>([]);
  const [attendeesCount, setAttendeesCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(-1);
  const [loading, setLoading] = useState(true); // data loading flag
  const [selectedAttendee] = useState<IAttendee>();
  const [searchKey, setSearchKey] = useState("");
  const [selectedFilters, setSelectedFilters] = useState<any[]>([]);
  const [attendeeFilterIndex, setAttendeeFilterIndex] = useState<number>(0);
  const [actionDialog, setActionDialog] = useState<dialogType>({
    open: false,
    title: "",
    content: <></>,
    maxWidth: false,
    fullWidth: false,
    isLoading: false,
    onConfirm: () => { },
    confirmLabel: "Save"
  });
  const { eventId } = useParams() as any;
  const [state, dispatch] = useContext(StoreContext);
  const api = useContext(APIContext);
  const redirect = useRedirect();
  const searchRef = useRef<any>();
  const csvUploaderRef = useRef<any>();
  const notificationRef = useRef<any>();
  const location = useLocation().search;
  // var jobChecker: any;
  // permissions
  const canManageAttendee = useHasPermissions(PERMISSIONS.CAN_MANAGE_ATTENDEE);
  const canDeleteEvent = useHasRole(ROLES.SYSTEM_DEVELOPER); //useHasPermissions(PERMISSIONS.CAN_DELETE_EVENT);
  useEffect(() => {
    // fetch the selected event if it wasn't set in the store
    if (eventId && !state.selectedEvent) {
      fetchSelectedEvent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // check for search key and fetch attendees
    const search = new URLSearchParams(location).get("search");
    if (search) {
      setSearchKey(search);
      fetchAttendees(search);
    } else {
      fetchAttendees();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const fetchSelectedEvent = async () => {
    try {
      const event = await api.eventService.getEvent({ id: eventId });
      dispatch({ type: "SET_SELECTED_EVENT", payload: event });
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const fetchAttendees = async (keyword: string = "", page: number = 0) => {
    let selectedEventId = state.selectedEvent?.id || eventId;

    try {
      setLoading(true);

      const categoryFilterValue = getCategoryFilterValue();
      // fetch data using keyword or selected filters if necessary
      let content: any;
      let currentPage: any;
      // let pages: any;
      let total: any;
      if (keyword.length > 0 || selectedFilters.length > 0) {
        ({
          content,
          currentPage,
          // pages,
          total,
        } = (await api.attendeeService.searchAttendees(selectedEventId, {
          ...(categoryFilterValue && { category: categoryFilterValue }),
          filters: getSelectedFilters(),
          search: keyword,
          page: page || 0,
          limit: 50,
        })) as any);
      } else {
        ({
          content,
          currentPage,
          // pages,
          total,
        } = (await api.attendeeService.getEventAttendees(selectedEventId, {
          page: page,
        })) as any);
      }

      setLoading(false);

      // show data
      if (page) {
        setAttendees([...attendees, ...content]);
      } else {
        setAttendees(content);
        setAttendeesCount(total);
      }

      setCurrentPage(currentPage);
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const getSelectedFilters = () => {
    // exclude category from filter model
    let filters = selectedFilters.filter(
      (filter) => filter.key !== filterOptions[0].key
    );

    return filters;
  };

  const getCategoryFilterValue = () => {
    let categoryFilter = selectedFilters.filter(
      (filter) => filter.key === filterOptions[0].key
    )[0]; // select only category filter
    if (categoryFilter) {
      return categoryFilter.value;
    }
    return null;
  };

  // TODO when endpoint implemented
  // const getSubCategoryFilterValue = () => {
  //   let subCategoryFilter = selectedFilters.filter(filter => filter.key === filterOptions[].key)[0]; // select only subcategory filter
  //   if (subCategoryFilter) {
  //     return subCategoryFilter.value;
  //   }
  //   return null;
  // }

  // const getSortMethod = () => {
  //   return {
  //     name: "ASC",
  //   };
  // };

  const handleListPagination = () => {
    if (loading === false && attendees.length < attendeesCount) {
      fetchAttendees(searchKey, currentPage + 1);
    }
  };

  const onSearchClick = (e: any) => {
    setCurrentPage(-1);
    redirect(
      `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.ATTENDEES}?search=${searchKey}`
    );
    fetchAttendees(searchKey);
  };

  const handleSearchClear = () => {
    setCurrentPage(-1);
    redirect(
      `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.ATTENDEES}`
    );
    setSearchKey("");
    fetchAttendees();
  };

  const handleSearchKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      setCurrentPage(-1);
      redirect(
        `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.ATTENDEES}?search=${searchKey}`
      );
      fetchAttendees(searchKey);
    }
  };

  const removeFilter = (key: string) => {
    const newFilters = selectedFilters.filter((filter) => filter.key !== key);
    setSelectedFilters(newFilters);
    setCurrentPage(-1);
  };

  const setNewFilter = (newFilter: any) => {
    const selectedFilter = selectedFilters.filter((filter: any) => {
      return filter.key === newFilter.key;
    })[0];

    setCurrentPage(-1);
    if (selectedFilter) {
      setSelectedFilters(
        selectedFilters.map((filter) =>
          filter.key === newFilter.key
            ? { ...filter, value: newFilter.value }
            : filter
        )
      );
    } else {
      setSelectedFilters([...selectedFilters, ...[newFilter]]);
    }
  };

  const handleBulkDelete = async (items: number[]) => {
    try {
      setCurrentPage(-1);
      await Promise.all(
        items.map((item) => {
          return api.attendeeService.delete(item);
        })
      );
      fetchAttendees();
      notificationRef.current?.show(
        "Attendees successfully deleted",
        notificationType.Success
      );
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const handleDeleteAttendee = async (id: number) => {
    try {
      await api.attendeeService.delete(id);
      fetchAttendees();
      notificationRef.current?.show(
        "Attendee successfully deleted",
        notificationType.Success
      );
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  // checkout the selected attendees which have the 'attended' status
  const handleBulkCheckout = async (checkedItems: number[]) => {
    const attendedItems = attendees
      .filter(
        (item) =>
          checkedItems.findIndex((checkedItem) => checkedItem === item.id) !==
          -1 && item.registrationStatus === registrationStatus.ATTENDED
      )
      .map((item) => item.id);

    try {
      //show loading dialog
      setActionDialog({
        ...actionDialog,
        open: true,
        title: "Processing data...",
        isLoading: true,
      });

      // make request
      await api.attendeeService.checkoutAttendees(eventId, attendedItems);

      // refresh the list
      fetchAttendees();

      // hide dialog
      setActionDialog({
        ...actionDialog,
        open: false,
        isLoading: false,
      });

      //show notification message
      notificationRef.current?.show(
        "Attendees checked out",
        notificationType.Success
      );
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  // checkout attendees
  const handleCheckoutAll = async () => {
    try {
      //show loading dialog
      setActionDialog({
        ...actionDialog,
        open: true,
        title: "Processing data...",
        isLoading: true,
      });

      // make request
      await api.attendeeService.checkoutAttendees(eventId);

      // refresh the list
      fetchAttendees();

      // hide dialog
      setActionDialog({
        ...actionDialog,
        open: false,
        isLoading: false,
      });

      //show notification message
      notificationRef.current?.show(
        "Attendees checked out",
        notificationType.Success
      );
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const handleDeleteAll = async () => {
    try {
      //show loading dialog
      setActionDialog({
        ...actionDialog,
        open: true,
        title: "Deleting attendees...",
        isLoading: true,
      });
      // make request
      const response = await api.attendeeService.deleteAll(
        state.selectedEvent.id
      );
      setAttendees([]);
      setAttendeesCount(0);
      // hide dialog
      setActionDialog({
        ...actionDialog,
        open: false,
        isLoading: false,
      });
      setAttendeeFilterIndex(prev => prev += 1);
      notificationRef.current?.show(response, notificationType.Success);
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  // actions applied on selected items
  const bulkActions = [
    {
      label: "Delete",
      key: "delete",
      callback: handleBulkDelete,
      startIcon: <BiTrash />,
    },
    {
      label: "Check out",
      key: "checkout",
      callback: handleBulkCheckout,
      startIcon: <FiLogOut />,
    },
  ];

  // actions shown on top right
  const customActions = [];

  if (canDeleteEvent) {
    customActions.push(
      {
        label: "Delete all",
        key: "delete-all",
        callback: handleDeleteAll,
        startIcon: <BiTrash />,
      },
      {
        label: "Check out all",
        key: "checkout-all",
        callback: handleCheckoutAll,
        startIcon: <FiLogOut />,
      }
    );
  }

  // const token = localStorage.getItem("fielddrive-token");

  if (!eventId || eventId === "undefined") {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        paddingTop="50px"
      >
        Please, select an event!
      </Box>
    );
  }

  const showInfoFieldDialog = () => {
    setActionDialog({
      open: true,
      title: "Add Third Party Id",
      content: <SingleTextField setActionDialog={setActionDialog} />,
      maxWidth: false,
      fullWidth: false,
      isLoading: false,
    });
  };

  const manageCategoryDialog = () => {
    setActionDialog({
      open: true,
      title: "Manage categories",
      fullWidth: true,
      content: <CategoryOverview />,
      isLoading: false,
    });
  }

  return (
    <>
      <Box sx={classes.wrapper}>
        <Box sx={classes.contentWrapper}>
          <Box sx={classes.topActions}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <FdTypography variant="h3" label="Attendees" />
              <FdTypography
                variant="subtitle1"
                style={{ lineHeight: 1, fontSize: "14px", color: "#787878" }}
                label={
                  <>
                    {" "}
                    <RiGroupLine
                      style={{
                        position: "relative",
                        top: "3px",
                        marginRight: "7px",
                        color: theme.palette.text.primary,
                        fontSize: "18px",
                      }}
                    />{" "}
                    Total attendees:{" "}
                    <Box component="span" fontWeight="bold">
                      {attendeesCount}
                    </Box>{" "}
                  </>
                }
              />
            </Box>
            <Box textAlign="right" paddingRight="20px" sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <FdButton
                variant="text"
                color="primary"
                size="small"
                onClick={manageCategoryDialog}
                startIcon={<BiGridAlt />}
                ButtonName="Manage categories" />

              {canManageAttendee && (
                <DropdownButton
                  label="Add attendees"
                  endIcon={<BiChevronDown />}
                  options={[
                    {
                      key: "single-attendee",
                      label: "Single attendee",
                      callback: () => {
                        redirect(
                          `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.NEW_ATTENDEE}`
                        );
                      },
                      startIcon: <RiUserLine fontSize="medium" />,
                    },
                    {
                      key: "multiple-attendees",
                      label: "Upload attendees CSV",
                      callback: () => {
                        csvUploaderRef.current.openDialog();
                      },
                      startIcon: <RiGroupLine fontSize="medium" />,
                    },
                    {
                      key: "pull-attendee",
                      label: "Pull Attendee",
                      callback: () => {
                        showInfoFieldDialog()
                      },
                      startIcon: <RiUserLine fontSize="medium" />,
                    },
                  ]}
                />
              )}
            </Box>
          </Box>
          <Box sx={classes.topFilters} display="flex">
            {state.selectedEvent && (
              <AttendeeFilters
                key={attendeeFilterIndex}
                eventId={state.selectedEvent.id}
                onFilterSelect={(filter: any) => {
                  setNewFilter(filter);
                }}
              />
            )}
            <Box sx={classes.searchForm}>
              <FdTextField
                sx={classes.searchInput}
                placeholder="Search"
                type="text"
                inputRef={searchRef}
                name="search"
                onChange={(e) => {
                  const keyword = e.target.value;
                  setSearchKey(keyword);
                  // if (keyword.length === 0) {
                  //   setSearchKey("");
                  // }
                }}
                value={searchKey}
                autoFocus
                onKeyDown={handleSearchKeyDown}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BiSearch size="18" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={classes.clearIcon}
                      onClick={handleSearchClear}
                    >
                      {searchKey.length > 0 && <BiX size="20" />}
                    </InputAdornment>
                  ),
                }}
              />

              <FdButton
                variant="contained"
                color="primary"
                onClick={onSearchClick}
                sx={classes.searchButton}
                ButtonName="Search"
              />
            </Box>
          </Box>

          <Box sx={classes.listContentActions}>
            <Box sx={classes.selectedFilters}>
              {selectedFilters.map((filter, index) => (
                <FdChip
                  sx={classes.filterChip}
                  key={index}
                  aria-label="attendeeFilterChip"
                  color="primary"
                  label={`${filterOptions.filter(
                    (option) => filter.key === option.key
                  )[0].label
                    } is ${filter.value}`}
                  onDelete={() => {
                    removeFilter(filter.key);
                  }}
                />
              ))}
            </Box>

            {/* {currentPage !== -1 && (
              <Button
                startIcon={<BiListUl />}
                href={`${api.apiUrl}/events/${state.selectedEvent?.id}/csvexport?token=${token}`}
              >
                Export Attendees List into CSV
              </Button>
            )} */}
          </Box>

          {currentPage !== -1 && (
            <Box sx={classes.listContent}>
              <GenericList
                items={attendees}
                type={dataType.ATTENDEES}
                onBottomScroll={handleListPagination}
                onDeleteItem={
                  canManageAttendee ? handleDeleteAttendee : undefined
                }
                // onEditItem={(item: IAttendee) => {
                //   redirect(
                //     `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.ATTENDEES}/${item.id}/${routePaths.EDIT}`
                //   );
                // }}
                style={{ width: "100%" }}
                selectedItem={selectedAttendee}
                onSelectItem={(item: IAttendee) => {
                  redirect(
                    `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.ATTENDEES}/${item.id}/${routePaths.EDIT}`
                  );
                }}
                isLoading={loading}
                bulkActions={canManageAttendee ? bulkActions : undefined}
                customActions={canManageAttendee ? customActions : undefined}
              />
            </Box>
          )}

          {currentPage === -1 && <Loading />}
        </Box>

        {/* badge preview part */}
        {/* <Box sx={classes.badgeWrapper}>
        {selectedAttendee && <BadgePreview attendee={selectedAttendee} />}
      </Box> */}
      </Box>

      <CSVUploadFlow
        ref={csvUploaderRef}
        type={dataType.ATTENDEES}
        eventId={state.selectedEvent?.id}
        onCSVUpload={async (status: any, result: any) => {
          if (status === jobStatus.FINISHED) {
            await fetchAttendees();
            setAttendeeFilterIndex(prev => prev += 1);
            notificationRef.current?.show(result, notificationType.Success);
          }

          if (status === jobStatus.ERROR) {
            notificationRef.current?.show(result, notificationType.Error);
          }
        }}
      />

      <NotificationMessage ref={notificationRef} />

      {actionDialog.open && (
        <SimpleActionDialog
          onClose={() => {
            setAttendeeFilterIndex(prev => prev += 1);
            setActionDialog({ ...actionDialog, content: <></>, open: false });
          }}
          open={actionDialog.open}
          title={actionDialog.title}
          content={actionDialog.content}
          maxWidth={actionDialog.maxWidth as any}
          fullWidth={actionDialog.fullWidth}
          isLoading={actionDialog.isLoading}
          onConfirm={actionDialog.onConfirm}
          confirmLabel={actionDialog.confirmLabel}
        />
      )}
    </>
  );
};

export default AttendeesOverview;
